export default __webpack_public_path__ + "static/media/about.3495bba2.jpg";